import { Skeleton } from 'common/src/designSystem/components/skeleton';
import { Role } from 'common/src/generated/types';
import { useParams, useTranslate } from 'common/src/util/dependencies/dependencies';
import { groupBy } from 'lodash-es';
import * as React from 'react';
import { useRoleUsesQuery } from '../../../../generated/graphqlHooks';

export const RoleUses = ({ role }: { role: Pick<Role, 'id' | 'name'> }) => {
    const { organizationId } = useParams();
    const translate = useTranslate();
    const { data, isLoading } = useRoleUsesQuery({ organizationId, roleId: role.id });

    if (isLoading) {
        return <Skeleton borderRadius="$1" height={18} width={160} />;
    } else {
        const uses = data.organization.role.uses;
        if (uses.length === 0) {
            return <div>{translate('ce_r_le_n_est_p_61959')}</div>;
        } else {
            const byUserInfo = groupBy(uses, (_) => _.userInfo.id);

            return (
                <div>
                    <div>{translate('les_responsable_31151')}</div>
                    {Object.entries(byUserInfo).map(([uid, array]) => (
                        <dl key={uid}>
                            <dt>{translate('_1_sur_84610', array[0].userInfo.name)}</dt>
                            {array.map((item) =>
                                item.__typename === 'UsersPosition' ? (
                                    <dd key={item.position.id}>
                                        {translate('la_mission_1_50232', item.position.name)}
                                    </dd>
                                ) : (
                                    <dd key={item.positionCategory.id}>
                                        {translate(
                                            'la_cat_gorie_1_00613',
                                            item.positionCategory.name
                                        )}
                                    </dd>
                                )
                            )}
                        </dl>
                    ))}
                </div>
            );
        }
    }
};
